<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card outlined>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Reimposta password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="user.new_password1"
                :error-messages="error.new_password1"
                required
                label="Nuova password"
                prepend-icon="fa-lock"
                type="password"
              />
              <v-text-field
                v-model="user.new_password2"
                :error-messages="error.new_password2"
                required
                label="Nuova password (ripeti)"
                prepend-icon="fa-lock"
                type="password"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn depressed color="primary" @click="resetPasswordConfirm">
              Reimposta
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      user: {
        uid: null,
        token: null,
        new_password1: "",
        new_password2: "",
      },
      error: {
        new_password1: [],
        new_password2: [],
      },
    }
  },
  mounted() {
    this.user.uid = this.$route.params.uid
    this.user.token = this.$route.params.token
  },
  methods: {
    resetPasswordConfirm() {
      this.$store
        .dispatch("resetPasswordConfirm", this.user)
        .then((response) => {
          this.$store.commit("core/setSnack", {
            level: "success",
            msg: response.detail,
          })
          this.$router.push({ name: "Login" })
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          if (this.get(err.response.data, "new_password1")) {
            this.error.new_password1 = err.response.data.new_password1
          }
          if (this.get(err.response.data, "new_password2")) {
            this.error.new_password1 = err.response.data.new_password2
          }
          if (this.get(err.response.data, "non_field_errors")) {
            this.$store.commit("core/setSnack", {
              level: "error",
              msg: err.response.data.non_field_errors,
            })
          }
          if (this.get(err.response.data, "token")) {
            this.$store.commit("core/setSnack", {
              level: "error",
              msg:
                "Il link per attivare la password è scaduto o è già stato usato",
            })
          }

          // console.log(err.response.data)
        })
    },
  },
}
</script>
